/* =============================================================
   D'Avila — Hover nas categorias do menu desktop
   Abre/fecha o <details> automaticamente ao passar o mouse,
   mantendo o comportamento de click (acessibilidade)
   ============================================================= */
(function () {
  'use strict';

  function updateMegaMenuTop() {
    // Calcula onde o dropdown deve abrir (logo abaixo do header VISIVEL).
    //
    // Problema evitado: no Dawn a .shopify-section-header (wrapper) fica no
    // fluxo normal e rola pra fora com o scroll. O que fica sticky no topo
    // e' o elemento sticky-header (ou header.header-wrapper) DENTRO dela.
    // Usar rect.bottom da wrapper daria valor negativo ao scrollar, e o
    // dropdown abriria por cima do menu — o bug reportado.
    //
    // Fix: preferir o <sticky-header>/<header> visivel; e se a section
    // estiver com .shopify-section-header-hidden (scroll pra baixo rapido),
    // fechar qualquer mega-menu aberto pra nao ficar solto na tela.
    var stickyEl = document.querySelector('sticky-header');
    var headerEl = stickyEl
      || document.querySelector('.section-header header, .shopify-section-header header, .header-wrapper, header.header');
    if (!headerEl) return;

    var section = headerEl.closest('.shopify-section-header, #shopify-section-header, .section-header');
    if (section && section.classList.contains('shopify-section-header-hidden')) {
      document.querySelectorAll('.header__inline-menu details.mega-menu[open]').forEach(function (d) {
        d.removeAttribute('open');
      });
      return;
    }

    var rect = headerEl.getBoundingClientRect();
    var top = Math.max(0, rect.bottom);
    document.documentElement.style.setProperty('--davila-mega-top', top + 'px');
  }

  function organizeMegaMenuColumns() {
    // Agrupa items do mega-menu por "cabeças" (links com href="#")
    // Cada cabeça vira uma coluna que contém os items abaixo dela
    document.querySelectorAll('.header__inline-menu .mega-menu__list').forEach(function (list) {
      if (list.dataset.davilaOrganized === '1') return;
      list.dataset.davilaOrganized = '1';

      var items = Array.from(list.children);
      var groups = [];
      var currentGroup = null;

      items.forEach(function (li) {
        var link = li.querySelector('a.mega-menu__link--level-2');
        if (!link) return;
        var href = link.getAttribute('href') || '';
        var isLabel = href === '#' || href === '';

        if (isLabel) {
          currentGroup = { label: li, items: [] };
          groups.push(currentGroup);
        } else if (currentGroup) {
          currentGroup.items.push(li);
        } else {
          // Item sem cabeça antes — vai pra coluna sozinho
          groups.push({ label: null, items: [li] });
        }
      });

      // Reorganiza o DOM: cada grupo vira uma coluna
      list.innerHTML = '';
      groups.forEach(function (group) {
        var column = document.createElement('li');
        column.className = 'davila-megamenu-column';

        if (group.label) {
          // Move o <a> da label pra fora do <li> original
          var labelLink = group.label.querySelector('a.mega-menu__link--level-2');
          if (labelLink) column.appendChild(labelLink);
        }

        // Adiciona os items (mantém o <a> de cada)
        group.items.forEach(function (item) {
          var itemLink = item.querySelector('a.mega-menu__link--level-2');
          if (itemLink) column.appendChild(itemLink);
        });

        list.appendChild(column);
      });
    });
  }

  // Mapa de sintaxe ::CODE → { label, classe CSS }
  var BADGE_MAP = {
    'BEST':    { label: 'MAIS VENDIDO', cls: 'davila-badge--blue' },
    'NOVO':    { label: 'NOVO',        cls: 'davila-badge--green' },
    'OFF':     { label: 'OFERTA',      cls: 'davila-badge--red' },
    'HOT':     { label: 'POPULAR',     cls: 'davila-badge--orange' },
    'PREMIUM': { label: 'PREMIUM',     cls: 'davila-badge--gold' },
    'FRETE':   { label: 'FRETE GRÁTIS', cls: 'davila-badge--green-dark' }
  };

  function processBadgeInElement(el) {
    if (!el || el.dataset.davilaBadgeProcessed === '1') return;

    // Pega o texto direto do elemento (ignora filhos HTML)
    var raw = '';
    for (var i = 0; i < el.childNodes.length; i++) {
      var node = el.childNodes[i];
      if (node.nodeType === Node.TEXT_NODE) raw += node.textContent;
    }
    raw = raw.trim();

    var match = raw.match(/^(.*?)\s*::([A-Za-z]+)\s*$/);
    if (!match) return;

    var cleanText = match[1].trim();
    var code = match[2].toUpperCase();
    var badge = BADGE_MAP[code];
    if (!badge) return;

    el.dataset.davilaBadgeProcessed = '1';

    // Substitui apenas os text nodes pelo texto limpo + span do badge
    var firstTextNodeFound = false;
    var toRemove = [];
    for (var j = 0; j < el.childNodes.length; j++) {
      var n = el.childNodes[j];
      if (n.nodeType === Node.TEXT_NODE) {
        if (!firstTextNodeFound) {
          n.textContent = cleanText;
          firstTextNodeFound = true;
        } else {
          toRemove.push(n);
        }
      }
    }
    toRemove.forEach(function (n) { n.remove(); });

    // Adiciona o badge no final
    var span = document.createElement('span');
    span.className = 'davila-badge ' + badge.cls;
    span.textContent = badge.label;
    el.appendChild(span);
  }

  function processBadgesInMenu() {
    // Mega-menu desktop: <a> de items
    document.querySelectorAll('.header__inline-menu .mega-menu__link, .header__inline-menu .mega-menu__link--level-2').forEach(processBadgeInElement);
    // Drawer mobile: títulos dos cards
    document.querySelectorAll('.davila-menu-card__title, .davila-menu-section-title').forEach(processBadgeInElement);
  }

  function addViewAllLinks() {
    // Adiciona "Ver tudo" no final de cada coluna do mega-menu,
    // apontando pra coleção da categoria pai (Aventura, Churrasco, etc)
    document.querySelectorAll('.header__inline-menu .mega-menu__content').forEach(function (content) {
      var parentUrl = content.dataset.megamenuUrl;
      if (!parentUrl || parentUrl === '#' || parentUrl === '') return;

      var firstColumn = content.querySelector('.davila-megamenu-column');
      if (!firstColumn || firstColumn.querySelector('.davila-viewall')) return;

      var viewAll = document.createElement('a');
      viewAll.href = parentUrl;
      viewAll.className = 'davila-viewall';
      viewAll.innerHTML = 'Ver tudo <span class="davila-viewall__arrow" aria-hidden="true">→</span>';
      firstColumn.appendChild(viewAll);
    });
  }

  function closeAllMegaMenus() {
    document.querySelectorAll('.header__inline-menu details.mega-menu[open]').forEach(function (d) {
      d.removeAttribute('open');
    });
  }

  function forceHeaderReveal() {
    // Se o Dawn escondeu o header (scroll pra baixo), remove as classes
    // hidden pra ele voltar a aparecer antes de abrir o dropdown.
    var section = document.querySelector('.section-header, .shopify-section-header');
    if (!section) return;
    if (section.classList.contains('shopify-section-header-hidden')) {
      section.classList.remove('shopify-section-header-hidden');
      // Reaplica o top calculado imediatamente pra evitar 1 frame de posicao errada
      updateMegaMenuTop();
    }
  }

  function watchHeaderClass() {
    // Observer que fecha os megamenus no MOMENTO em que o header some
    // (a classe .shopify-section-header-hidden e' adicionada). Evita o
    // dropdown flutuando na tela sem contexto.
    var section = document.querySelector('.section-header, .shopify-section-header');
    if (!section || section.dataset.davilaHeaderObs === '1') return;
    section.dataset.davilaHeaderObs = '1';
    var obs = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.attributeName !== 'class') return;
        if (section.classList.contains('shopify-section-header-hidden')) {
          closeAllMegaMenus();
        }
        // Recalcula o top toda vez que a classe muda (sticky/hidden/reveal)
        updateMegaMenuTop();
      });
    });
    obs.observe(section, { attributes: true, attributeFilter: ['class'] });
  }

  function setupHoverMenu() {
    // Só aplica em telas desktop (>= 990px)
    if (window.matchMedia('(max-width: 989px)').matches) return;

    organizeMegaMenuColumns();
    addViewAllLinks();
    processBadgesInMenu();
    updateMegaMenuTop();
    watchHeaderClass();
    window.addEventListener('scroll', updateMegaMenuTop, { passive: true });
    window.addEventListener('resize', updateMegaMenuTop);

    var detailsList = document.querySelectorAll('.header__inline-menu details');
    detailsList.forEach(function (details) {
      if (details.dataset.davilaHoverInit === '1') return;
      details.dataset.davilaHoverInit = '1';

      var closeTimer = null;

      details.addEventListener('mouseenter', function () {
        if (closeTimer) {
          clearTimeout(closeTimer);
          closeTimer = null;
        }
        // Se o header foi escondido pelo scroll, forca aparecer antes de abrir
        forceHeaderReveal();
        // Fecha outros details abertos
        detailsList.forEach(function (other) {
          if (other !== details && other.hasAttribute('open')) {
            other.removeAttribute('open');
          }
        });
        details.setAttribute('open', '');
      });

      details.addEventListener('mouseleave', function () {
        closeTimer = setTimeout(function () {
          details.removeAttribute('open');
        }, 180);
      });

      // Click no summary (categoria principal) navega pra coleção
      // — dropdown já abre via hover, então click deve ser navegação
      var summary = details.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', function (e) {
          var content = details.querySelector('.mega-menu__content, .header__submenu');
          var url = content && content.dataset.megamenuUrl;
          if (url && url !== '#' && url !== '') {
            e.preventDefault();
            window.location.href = url;
          }
        });
      }
    });
  }

  function setupBadgesMobile() {
    // Badges no drawer mobile sempre rodam (independente de viewport)
    processBadgesInMenu();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setupHoverMenu();
      setupBadgesMobile();
    });
  } else {
    setupHoverMenu();
    setupBadgesMobile();
  }

  // Re-inicializa em resize (caso o usuário mude de mobile pra desktop)
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(setupHoverMenu, 200);
  });
})();
